import { render } from "./KnowledgeForm.vue?vue&type=template&id=1390b68e"
import script from "./KnowledgeForm.vue?vue&type=script&lang=js"
export * from "./KnowledgeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__